import PageLayer from "@/Layouts/views/PageLayer";
import SystemSettingsContainer from "@/Settings/components/SystemSettings/SystemSettingsContainer";

// MUI
import { Stack, SvgIcon } from "@mui/material";

// Icons
import { ReactComponent as Icon } from "@/assets/icons/header/settings/SystemSettingsIcon.svg";

export default function SystemSettings() {
	return (
		<PageLayer
			title="System Settings"
			icon={
				<Stack width={1} direction={"row"} justifyContent={"center"} alignItems={"center"}>
					<SvgIcon viewBox="-2 -2 24 24" className="text-[var(--strong-purple-color)] !text-[27px]" component={Icon} />
				</Stack>
			}
		>
			<SystemSettingsContainer />
		</PageLayer>
	);
}
